import {
  Box,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { ArrowDropDown, ArrowDropUp, DragHandle } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { styles } from '../clientes.styles'
import { KPIItemType, KPIItemTypes, LandingSujectKpisModel } from '../clients.model'

export interface KPIListItemProps {
  KPI: number
  itemType: KPIItemTypes
  renderArrow: boolean
  gridProps?: any
  align?: 'right' | 'center' | 'left'
}

const KPIListItem: React.FC<KPIListItemProps> = ({
  KPI,
  itemType,
  renderArrow,
  gridProps,
  align
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'clients', 'enums'])

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const responsive = useMediaQuery(currentTheme.breakpoints.down('xs'))
  const horizontalDisposition = useMediaQuery(currentTheme.breakpoints.between('sm', 'md'))

  const renderArrows = (count: number) => {
    if (renderArrow) {
      if (count > 0) {
        return <ArrowDropUp className={classes.iconArrowDropUp} />
      } else if (count < 0) {
        return <ArrowDropDown className={classes.iconArrowDropDown} />
      }
      return <DragHandle className={classes.iconArrowNeutral} />
    }

    return <div className={classes.iconArrowDropDown}></div>
  }

  const iconGridSize = align === 'center' ? undefined : horizontalDisposition ? 3 : 6
  const textGridSize =
    align === 'center' ? undefined : renderArrow ? (horizontalDisposition ? 9 : 6) : 12
  const primaryTextAlign = responsive ? (renderArrow ? 'left' : 'center') : align
  const secondaryTextAlign = responsive ? 'center' : align ?? 'right'

  return (
    <Grid
      key={`${KPI}-${itemType}`}
      item
      {...gridProps}
      xs={responsive ? 12 : 4}
      md={12}
      style={{ marginRight: currentTheme.spacing(2) }}
    >
      <ListItem>
        <Grid container>
          <Grid
            container
            item
            xs={12}
            direction="row"
            wrap="nowrap"
            style={{
              justifyContent:
                !responsive && !horizontalDisposition
                  ? 'flex-end'
                  : align === 'center'
                  ? 'center'
                  : undefined
            }}
          >
            <Grid
              item
              xs={iconGridSize}
              style={{
                display: responsive && !renderArrow ? 'none' : 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}
            >
              <ListItemIcon>
                {renderArrows(itemType === KPIItemType.ACTIVE_CONTRACTS ? 0 : KPI)}
              </ListItemIcon>
            </Grid>
            <Grid item xs={textGridSize}>
              <ListItemText
                primaryTypographyProps={{
                  variant: 'h4',
                  align: primaryTextAlign
                }}
                primary={t(`clients:landingPage.kpis.${itemType}.primaryText`, {
                  kpi: Math.abs(KPI)
                })}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <ListItemText
              secondaryTypographyProps={{ align: secondaryTextAlign }}
              secondary={t(`clients:landingPage.kpis.${itemType}.secondaryText`)}
            />
          </Grid>
        </Grid>
      </ListItem>
    </Grid>
  )
}

export default KPIListItem
